export const DOCUMENT_ID_POLLING_CONFIG = {
  MAX_RETRY: 10,
  DELAY: 1000,
};